export const convertFormatFromApiToJs = (dt:string) => {
    const dict:{[key: string]: string }= {
        "ddd dd/MM": "D dd/mm",
        "ddd MM/dd": "D mm/dd",
        "ddd dd/MM/yyyy": "D dd/mm/yy",
        "ddd MM/dd/yyyy": "D mm/dd/yy",
        "dd/MM": "dd/mm",
        "MM/dd": "mm/dd",
        "dd/MM/yyyy": "dd/mm/yy",
        "MM/dd/yyyy": "mm/dd/yy",
        "dd-MM-YY": "dd-mm-yy"
    };

    return dict[dt];
}

export const convertFormatFromApiToMoment = (dt:string) => {
    const dict:{[key: string]: string } = {
        "ddd dd/MM": "ddd DD/MM",
        "ddd MM/dd": "ddd DD/MM",
        "ddd dd/MM/yyyy": "ddd DD/MM/YYYY",
        "ddd MM/dd/yyyy": "ddd MM/DD/YYYY",
        "dd/MM": "DD/MM",
        "MM/dd": "MM/DD",
        "dd/MM/yyyy": "DD/MM/YYYY",
        "MM/dd/yyyy": "MM/DD/YYYY",
        "dd-MM-YY": "DD-MM-YY",
        "ddMMyyyy": "DDMMYYYY",
        "dd/MM/yyyy HH:mm:ss": "MM/DD/YYYY HH:mm:ss"
    };

    return dict[dt];
}

